// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"mega-video_playerWrapper__zmEMW"};